import React from 'react'
import HrefLangHead from '@toasttab/shared/src/layout/HrefLangHead'
import { getSiteUrl } from '@toasttab/shared/src/utils/siteUtils'
import { useSiteMetadata } from '@toasttab/main/src/hooks/use-site-metadata'
import { SEOProps } from './SEO.d'
import applicationId from '../../../data/region/us/applicationId.json'

const SEO = ({
  canonical,
  children,
  description,
  language,
  localizedEntries,
  noIndex = false,
  pathname,
  title
}: SEOProps) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    siteUrl: defaultSiteUrl,
    image,
    twitterUsername,
    hostName
  } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    url: `${getSiteUrl(defaultSiteUrl, language)}${
      pathname ? `/${pathname}` : ``
    }`,
    image,
    twitterUsername
  }

  const renderApplicationId = () => {
    return (
      <script type='application/ld+json'>
        {JSON.stringify(applicationId)}
      </script>
    )
  }

  const renderLocalizationHrefLangs = () => {
    return (
      <>
        {localizedEntries && localizedEntries?.length > 0 && (
          <HrefLangHead
            canonical={canonical ? `${defaultSiteUrl}${canonical}` : seo.url}
            currentLanguage={language}
            defaultSiteUrl={defaultSiteUrl}
            localizedEntries={localizedEntries}
            slug={pathname}
          />
        )}
      </>
    )
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name='viewport' content='width=device-width, initial-scale=1' />
      <meta
        name='description'
        content={description ? description : seo.description}
      />
      <meta
        name='robots'
        content={noIndex ? 'noindex, nofollow' : 'index, follow'}
      />
      <meta property='og:url' content={seo.url} />
      <meta property='og:title' content={title} />
      <meta
        property='og:image'
        content='https://d2w1ef2ao9g8r9.cloudfront.net/images/otl.jpg'
      />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:site' content={seo.twitterUsername} />
      <meta name='twitter:title' content={seo.title} />
      <meta
        name='twitter:description'
        content={description ? description : seo.description}
      />
      <meta name='twitter:image' content={seo.image} />
      <meta name='twitter:creator' content={seo.twitterUsername} />
      <link
        rel='icon'
        href='https://d2w1ef2ao9g8r9.cloudfront.net/images/icons/favicon.ico'
      />
      <link
        rel='canonical'
        href={canonical ? `${defaultSiteUrl}${canonical}` : seo.url}
      />
      <meta
        name='google-site-verification'
        content='LH_mX7y0DJk5nUgUOTzglaHQ0c9EEm5AtHam273KA0I'
      />
      <meta
        name='facebook-domain-verification'
        content='8fmbcvv517c7bmps9diwnv3uemb3v7'
      />
      {renderApplicationId()}
      {renderLocalizationHrefLangs()}
      {children}
    </>
  )
}

export default SEO
